'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var directoryContent = function directoryContent(cid, node, unixfs, path, resolve, depth, blockstore) {
  function yieldDirectoryContent() {
    return _yieldDirectoryContent.apply(this, arguments);
  }

  function _yieldDirectoryContent() {
    _yieldDirectoryContent = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          offset,
          length,
          links,
          _iterator,
          _step,
          link,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              offset = options.offset || 0;
              length = options.length || node.Links.length;
              links = node.Links.slice(offset, length);
              _iterator = _createForOfIteratorHelper(links);
              _context.prev = 5;

              _iterator.s();

            case 7:
              if ((_step = _iterator.n()).done) {
                _context.next = 17;
                break;
              }

              link = _step.value;
              _context.next = 11;
              return _awaitAsyncGenerator(resolve(link.Hash, link.Name || '', "".concat(path, "/").concat(link.Name || ''), [], depth + 1, blockstore, options));

            case 11:
              result = _context.sent;

              if (!result.entry) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return result.entry;

            case 15:
              _context.next = 7;
              break;

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](5);

              _iterator.e(_context.t0);

            case 22:
              _context.prev = 22;

              _iterator.f();

              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 19, 22, 25]]);
    }));
    return _yieldDirectoryContent.apply(this, arguments);
  }

  return yieldDirectoryContent;
};

module.exports = directoryContent;